import React, { Component } from 'react';
import axios from 'axios';
import queryString from 'query-string';
import MainPage from './component/page/MainPage';
import { config } from './config';
import { AppContext } from './context/AppContext';
import './scss/App.scss';
import { InitialValues } from './form/InitialValues';

class App extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    // parse url for edit node NID
    const parsed = queryString.parse(window.location.search);
    let editId = false;
    if (typeof parsed.id !== 'undefined') {
      editId = parsed.id;
    }

    this.state = {
      entityId: editId,
      formData: {},
      formValue: {},
      loadingEntity: false,
      loadingFormData: false,
      entityLoadError: false
    };
  }

  async componentDidMount() {
    let self = this;

    // get form data like services/taxonomy
    this.setState({ loadingFormData: true });
    await axios.get(config.API_DOMAIN + '/api/organization/form-data.json').then((response) => {
      if (response.status === 200) {
        self.setState({ formData: response.data });
      }
      self.setState({ loadingFormData: false });
    }).catch((error) => {
      self.setState({ loadingFormData: false });
    });

    // if we are editing a node, we retrieve that node
    if (this.state.entityId) {
      this.setState({ loadingEntity: true });
      await axios.get(config.API_DOMAIN + '/api/organization/detail.json', {
        params: { id: this.state.entityId }
      }).then((response) => {
        if (response.status === 200 && response.data.success === true) {
          this.setState({ formValue: response.data.entity });
          self.context.showInfo();
        } else {
          self.setState({ entityLoadError: true });
        }
        self.setState({ loadingEntity: false });
      }).catch((error) => {
        self.setState({
          loadingEntity: false,
          entityLoadError: true
        });
      });
    } else {
      this.setState({ formValue: InitialValues })
    }
  }

  render() {
    if (this.state.loadingFormData) {
      return <div>Loading data...</div>
    } else if (this.state.loadingEntity) {
      return <div>Loading organization...</div>
    } else if (this.state.entityLoadError) {
      return <div>Failed to load this organization or this organization does not exist.</div>
    }

    return (
      <div className="organization-public-form">
        <div className="omb-pra-approval">
          Form Approved<br />
          OMB No. 0920-0255<br />
          Exp. 03/31/2026<br />
          Public reporting burden of this collection of information is estimated to average 8 minutes per response,
          including the time for reviewing instructions, searching existing data sources, gathering and maintaining
          the data needed, and completing and reviewing the collection of information. An agency may not conduct or
          sponsor, and a person is not required to respond to a collection of information unless it displays a
          currently valid OMB control number. Send comments regarding this burden estimate or any other aspect of this
          collection of information, including suggestions for reducing this burden to CDC/ATSDR Reports Clearance
          Officer; 1600 Clifton Road NE, MS D-74, Atlanta, Georgia 30333; Attn: OMB-PRA (0920-0255)
        </div>
        <div className="information-notice">
          <p>In our capacity as a referral service for information, NPIN maintains a nationally sourced, searchable database of organizations and facilities that support prevention and control of HIV/AIDS, viral hepatitis, STDs, and TB.</p>
          <p>These organizations/facilities may provide:</p>
          <ul>
            <li>HIV/STD/TB/hepatitis testing</li>
            <li>Prevention services</li>
          </ul>
          <ul>
            <li>Capacity building</li>
            <li>Treatment/care</li>
          </ul>
          <ul>
            <li>Support services</li>
          </ul>
          <p>or a combination of the above.</p>

          <p>Information entered into the NPIN database powers tools such as the GetTested testing locator utility and the PrEP Locator tool. If your organization provides any of the above services and you would like it to be included in NPIN’s searchable database, fill out the form below. Please note that required information is marked with a red asterisk (*). The form cannot be processed without all required information.</p>
        </div>
        <MainPage formData={this.state.formData} formValue={this.state.formValue} />
      </div>
    );
  }
}

export default App;
